const STORAGE_KEY = "mad_admin_session";
const TTL_MS = 1000 * 60 * 60 * 24 * 7; // 7 days

type Session = {
  token: string;
  username: string;
  expiresAt: number;
};

const getEnvCreds = () => ({
  username: import.meta.env.VITE_ADMIN_USER || "1",
  password: import.meta.env.VITE_ADMIN_PASS || "2"
});

const now = () => Date.now();

export const getSession = (): Session | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: Session = JSON.parse(raw);
    if (!parsed.token || !parsed.expiresAt) return null;
    if (parsed.expiresAt <= now()) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

const persistSession = (session: Session) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const isAuthenticated = () => !!getSession();

export const login = async (username: string, password: string) => {
  const creds = getEnvCreds();
  if (username !== creds.username || password !== creds.password) {
    throw new Error("invalid-credentials");
  }

  const session: Session = {
    token: crypto.randomUUID(),
    username,
    expiresAt: now() + TTL_MS
  };

  // Best effort to set backend cookie; session still lives in localStorage.
  try {
    await fetch("/api/admin/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password })
    });
  } catch {
    // Ignore; local session stays valid.
  }

  persistSession(session);
  return session;
};

export const logout = () => {
  localStorage.removeItem(STORAGE_KEY);
  fetch("/api/admin/logout", { method: "POST" }).catch(() => {});
};
